import { BCMSRecord, BCMSStateManagerCRUD, BrandingImage, useBCMSContext, useModel } from "@bcm-dev/bcms-vite";
import Classes from "model";
import ChatItem from "./classes/ChatItem";

import { CenterContentContainer, LeftColumnContainer, PageContainer, PageLayoutContainer, RightColumnContainer } from 'components/shared';
import ChatNavigationWidget from './components/ChatNavigationWidget';
import ChatWidget from './components/ChatWidget';

import "./styles.css";
import "./mobile.css";


export default function ChatPage(props) {
    const globalController = useBCMSContext();
    const { branding } = useModel();
    const options = branding.options || {};
    BCMSRecord.globalControllerFor(Classes, globalController);

    const data = { ...getDefaultPageData(), ...props.data ?? {} };
    const ui = { ...getDefaultPageUI(options), ...props.ui ?? {} };

    const controller = (state, setState) => ({
        data: state.data,
        ui: state.ui,

        onEndSession: () => {
            BCMSStateManagerCRUD.init(state)
                .update(["data", "messages"], [...state.data.messages, ChatItem.init(undefined, "ended")])
                .update(["ui", "sessionHasEnded"], true)
                .update(["ui", "showEndSessionPopup"], false)
                .submit(setState);
        },

        onMessageInput: value => {
            BCMSStateManagerCRUD.init(state)
                .update(["data", "messageInput"], value)
                .submit(setState);
        },

        onMessageAdd: (message, clearInput) => {
            BCMSStateManagerCRUD.init(state)
                .update(["data", "messages"], [...state.data.messages, message])
                .update(["data", "messageInput"], clearInput ? "" : state.data.messageInput)
                .submit(setState);
        },
        onUIClick: (prop, value) => (evt) => {
            const crud = BCMSStateManagerCRUD.init(state);

            if (prop === "showEndSessionPopup" && value === true) {
                crud
                    .update(["ui", "showEndSessionPopup"], value)
                    .update(["ui", "showFeaturePopup"], false)
                    .update(["ui", "showTranslationPopup"], false);
            } else {
                crud.update(["ui", prop], value);
            }

            crud.submit(setState);
        },
        onCloseTranslationPopup: () => {
            BCMSStateManagerCRUD.init(state)
                .update(["ui", "showInitialMessage"], true)
                .update(["ui", "showTranslationPopup"], false)
                .submit(setState);
        }
    });

    return (
        <PageContainer className="chat-page" state={{ data, ui }} controller={controller}>
            <ChatContent />
        </PageContainer>
    )
}

export const getDefaultPageData = () => ({
    messages: [],
    messageInput: ""
});

export const getDefaultPageUI = (options) => ({
    sessionHasEnded: false,
    showInitialMessage: options.language_chat_abi22 !== "true",
    showFeaturePopup: false,
    showEndSessionPopup: false,
    showTranslationPopup:  options.language_chat_abi22 === "true",
});

function ChatContent(props) {
    return (
        <PageLayoutContainer>
            <CenterContentContainer>
                <ChatWidget />
            </CenterContentContainer>
        </PageLayoutContainer>
    )
}